'use client'
import { useTranslation } from "react-i18next";

 function NotFoundPage() {
  const { i18n, t } = useTranslation();
  return (
    <div className="not-found">
        <div className="container container-full">
            <img className="not-found__img-skilet" src="/assets/images/thumbs/not-found-page-img-skilet.webp" alt="404-skilet" />
            <img className="not-found__img-fonar" src="/assets/images/thumbs/not-found-page-img-fonar.webp" alt="404-fonar" />
            <div className="content">
                <h1>{t('notFoundPage.title')}</h1>
                <h2><span className="not-found__hashtag">#</span>404</h2>
                <button className="btn btn-green btn-md pill" onClick={() => window.location.href = `/${i18n.language}`}>
                    {t('notFoundPage.btn')}
                </button>
            </div>
        </div>
    </div>
  );
}


export default NotFoundPage
